// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"46ddfe7d","952":"bb912988"}[chunkId] + ".chunk.js";
};